import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableColumn } from 'app/main/shared/shared/table/table-column';
import { ITableCellItem } from "../../../../../shared/shared/table/table-cell";
import { IDocumentDto } from "../../../dto/document-listing.dto";
import { DocumentListingApiService } from 'app/main/pages/documents/document-listing.api.service';
import * as moment from 'moment';
import { DocumentStatusesEnum } from '../../../dto/document-statuses.enum';
import { GlobalService } from 'app/global/global.service';
import { TranslocoService } from '@jsverse/transloco';
import { MetodikaStatus } from './document-metodika-status.enum';
import { RetryButtonComponent } from './document-metodika-retry-button.component';

const METODIKA_STATUS = {
    NOT_FOUND: 'Not found',
    DRAFT: 'Draft',
    PENDING: 'Pending',
    SENT: 'Sent',
    UNSENT: 'Unsent'
} as const;

const updateWaitingTimeMinutes = 5 as const;
const maxMetodikaUpdateTimeMinutes = 5 as const;
const minImportUpdatedAfterCreationTimeMinutes = 1 as const;

@Component({
    selector: 'app-metodika-document-status',
    templateUrl: './document-metodika-status.component.html',
    styleUrl: './document-metodika-status.component.scss'
})
export class DocumentMetodikaStatusComponent implements ITableCellItem, OnInit {
    @Input() dataItem: IDocumentDto;
    @Input() columnOptions: ITableColumn;

    constructor(
        private globalService: GlobalService,
        private documentListingApi: DocumentListingApiService,
        private translocoService: TranslocoService) { }

    status: MetodikaStatus;
    public MetodikaStatus = MetodikaStatus;
    loading = false;

    ngOnInit() {
        this.status = this.getMetodikaStatus();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.dataItem && !changes.dataItem.firstChange) {
            this.status = this.getMetodikaStatus();
        }
    }

    getMetodikaStatus(): MetodikaStatus {
        const metodikaStatus = this.dataItem?.metodika_status;
        if (!metodikaStatus || metodikaStatus === 'Not Found') {
            return MetodikaStatus.NotFound;
        }
        switch (metodikaStatus) {
            case 'Not Found':
                return MetodikaStatus.NotFound;
            case 'Draft':
                return MetodikaStatus.Draft;
            case 'Pending':
                return MetodikaStatus.Pending;
            case 'Sent':
                return MetodikaStatus.Sent; 
            case 'Unsent':
                return MetodikaStatus.Unsent;
            default:
                return MetodikaStatus.NotFound;
        }
    }

    onRetry() {
        this.loading = true;
        this.documentListingApi.retrySendingToMetodika(this.dataItem.id).subscribe({
            next: (response) => {
                this.status = MetodikaStatus.Pending;
            },
            error: (err) => {
                this.loading = false;
                const errorMessage = err?.error?.message || err?.message || 'An error occurred while resending the document';
                this.globalService.toastrError(errorMessage);
            },
            complete: () => {
                this.loading = false;
            }
        });
    }
}
